module.exports = __webpack_public_path__ + "img/en.fc5456b0.png";